let config = {
    title: `Demon Slayer: Blade Resonance`,
    copyright: '© JINFEN TRADE LIMITED',
    email: 'zhuwj1205@gmail.com',
    policy: 'https://ninjachakrawarriors.com/privacy_policy.html',
    term: 'https://ninjachakrawarriors.com/terms.html',
    introduceTitle: [
        `In Blade Resonance, you’ll train with the most elite members of the Demon Slayer Corps, each specializing in different techniques and forms. The game’s real-time combat system allows you to engage in fast-paced battles that require quick reflexes and strategic thinking. As you progress, you’ll unlock new abilities and weapons, and face increasingly powerful enemies, including some of the most feared demons in the series. Diverse Combat Experience`,
    ],
    introduceText: [
        {
            title: '【Master the Art of Demon Slaying】',
            text: [
                'Under the watchful eyes of the Hashira, refine your skills to become a formidable warrior. Each Hashira, voiced by renowned talents such as Natsuki Hanae (Tanjiro) and Akari Kitou (Nezuko), brings unique challenges and advanced techniques to the table. Whether you’re honing your swordsmanship with Giyu Tomioka or mastering the Breath of the Beast with Inosuke Hashibira, every training session pushes you closer to becoming a legendary Demon Slayer.'
            ]
        },
        {
            title: '【Dynamic Real-Time Combat】',
            text: [
                `Immerse yourself in exhilarating real-time battles that capture the pulse-pounding intensity of the anime. The fluid combat mechanics demand quick reflexes and sharp strategy—every encounter is a true test of your skills as you face down the most fearsome demons in the Demon Slayer Corps' history.`
            ]
        },
        {
            title: '【Engrossing Storyline & Detailed World】',
            text: [
                'Experience a storyline that seamlessly blends with the Hashira Training arc. With each battle and interaction, dive deeper into the lore and complexities of the Demon Slayer universe. The rich worldbuilding ensures that every decision you make impacts the unfolding narrative, creating a personalized journey through this epic saga.'
            ]
        },
        {
            title: '【Visual Splendor & Immersive Soundtrack】',
            text: [
                `Lose yourself in the stunning visuals that faithfully recreate the anime’s breathtaking style. Every scene is meticulously designed to pull you into the heart of the action. The game’s soundtrack, featuring iconic tracks, enhances the emotional depth of every moment, making each victory feel even more rewarding.`
            ]
        },
        {
            title: '【Worldwide Competitions & Leaderboards】',
            text: [
                'Test your mettle against players from around the globe in special events and competitive battles. Climb the leaderboards and prove that your blade resonates with unmatched power, solidifying your place among the greatest Demon Slayers of all time.'
            ]
        }
    ]
}
export default config;